var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "about-three-columns-main-container",
      class: _vm.block.section_bg_color
    },
    [
      _c(
        "div",
        {
          staticClass: "about-three-columns-inner-container",
          class: [_vm.block.desktop_layout, _vm.block.layoutHorizontal]
        },
        [
          _c("div", { staticClass: "about-three-columns-header-container" }, [
            _vm.block.header.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "about-three-column-header h2",
                    class: _vm.block.section_heading_color
                  },
                  [_vm._v(_vm._s(_vm.block.header))]
                )
              : _vm._e(),
            _vm.block.subheader.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "about-three-column-subheader subheader",
                    class: _vm.block.section_sub_heading_color
                  },
                  [_vm._v(_vm._s(_vm.block.subheader))]
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "about-three-columns-content-container" }, [
            _vm.block.block_image_1.length > 0
              ? _c(
                  "div",
                  { staticClass: "about-three-column-single-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "about-outer-column-image-container" },
                      [
                        _c("div", {
                          staticClass:
                            "about-three-column-single-image-container",
                          style: {
                            "background-image":
                              "url(" + _vm.block.block_image_1 + ")"
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "about-three-column-single-text-container"
                      },
                      [
                        _vm.block.block_text_1.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "h4 about-three-column-single-header",
                                class: _vm.block.block_heading_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_text_1))]
                            )
                          : _vm._e(),
                        _vm.block.block_body_copy_1.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "body-md-mobile body-md-tablet-up about-three-column-single-copy",
                                class: _vm.block.block_text_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_body_copy_1))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("button") &&
                        _vm.block.block_cta_title_1.length > 0
                          ? _c(
                              "v-button",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: {
                                  href: _vm.block.block_cta_link_1,
                                  tag: "a"
                                }
                              },
                              [_vm._v(_vm._s(_vm.block.block_cta_title_1))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("link") &&
                        _vm.block.block_cta_title_1.length > 0
                          ? _c(
                              "v-link",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: { href: _vm.block.block_cta_link_1 }
                              },
                              [_vm._v(_vm._s(_vm.block.block_cta_title_1))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm.block.block_image_2.length > 0
              ? _c(
                  "div",
                  { staticClass: "about-three-column-single-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "about-outer-column-image-container" },
                      [
                        _c("div", {
                          staticClass:
                            "about-three-column-single-image-container",
                          style: {
                            "background-image":
                              "url(" + _vm.block.block_image_2 + ")"
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "about-three-column-single-text-container"
                      },
                      [
                        _vm.block.block_text_2.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "h4 about-three-column-single-header",
                                class: _vm.block.block_heading_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_text_2))]
                            )
                          : _vm._e(),
                        _vm.block.block_body_copy_2.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "body-md-mobile body-md-tablet-up about-three-column-single-copy",
                                class: _vm.block.block_text_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_body_copy_2))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("button") &&
                        _vm.block.block_cta_title_2.length > 0
                          ? _c(
                              "v-button",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: {
                                  href: _vm.block.block_cta_link_2,
                                  tag: "a"
                                }
                              },
                              [_vm._v(_vm._s(_vm.block.block_cta_title_2))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("link") &&
                        _vm.block.block_cta_title_2.length > 0
                          ? _c(
                              "v-link",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: { href: _vm.block.block_cta_link_2 }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.block.block_cta_title_2) + "   "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm.block.block_image_3.length > 0
              ? _c(
                  "div",
                  { staticClass: "about-three-column-single-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "about-outer-column-image-container" },
                      [
                        _c("div", {
                          staticClass:
                            "about-three-column-single-image-container",
                          style: {
                            "background-image":
                              "url(" + _vm.block.block_image_3 + ")"
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "about-three-column-single-text-container"
                      },
                      [
                        _vm.block.block_text_3.length > 0
                          ? _c(
                              "h4",
                              {
                                staticClass: "about-three-column-single-header",
                                class: _vm.block.block_heading_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_text_3))]
                            )
                          : _vm._e(),
                        _vm.block.block_body_copy_3.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "body-md-mobile body-md-tablet-up about-three-column-single-copy",
                                class: _vm.block.block_text_color
                              },
                              [_vm._v(_vm._s(_vm.block.block_body_copy_3))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("button") &&
                        _vm.block.block_cta_title_3.length > 0
                          ? _c(
                              "v-button",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: {
                                  href: _vm.block.block_cta_link_3,
                                  tag: "a"
                                }
                              },
                              [_vm._v(_vm._s(_vm.block.block_cta_title_3))]
                            )
                          : _vm._e(),
                        _vm.block.cta_layout.includes("link") &&
                        _vm.block.block_cta_title_3.length > 0
                          ? _c(
                              "v-link",
                              {
                                staticClass:
                                  "hero-banner__cta about-three-column-cta",
                                class: _vm.block.cta_layout,
                                attrs: { href: _vm.block.block_cta_link_3 }
                              },
                              [_vm._v(_vm._s(_vm.block.block_cta_title_3))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }